import Vue from 'vue'
export default new Vue()



// WEBPACK FOOTER //
// ./src/services/bus.service.js